var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewCaseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8088 7.021C15.3573 7.021 14.7592 7.011 14.0146 7.011C12.1987 7.011 10.7055 5.508 10.7055 3.675V0.459C10.7055 0.206 10.5036 0 10.253 0H4.96363C2.49517 0 0.5 2.026 0.5 4.509V15.284C0.5 17.889 2.59022 20 5.16958 20H13.0463C15.5058 20 17.5 17.987 17.5 15.502V7.471C17.5 7.217 17.299 7.012 17.0475 7.013C16.6247 7.016 16.1177 7.021 15.8088 7.021Z",
    fill: "#FAAA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0842 0.56737C12.7852 0.25637 12.2632 0.47037 12.2632 0.90137V3.53837C12.2632 4.64437 13.1742 5.55437 14.2802 5.55437C14.9772 5.56237 15.9452 5.56437 16.7672 5.56237C17.1882 5.56137 17.4022 5.05837 17.1102 4.75437C16.0552 3.65737 14.1662 1.69137 13.0842 0.56737Z",
    fill: "#FAAA52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97408 7.89868H11.4181C11.8291 7.89868 12.1631 8.23168 12.1631 8.64268C12.1631 9.05368 11.8291 9.38768 11.4181 9.38768H5.97408C5.56308 9.38768 5.23008 9.05368 5.23008 8.64268C5.23008 8.23168 5.56308 7.89868 5.97408 7.89868Z",
    fill: "#FFEFDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.359 13.8929H5.97398C5.56298 13.8929 5.22998 14.2259 5.22998 14.6369C5.22998 15.0479 5.56298 15.3819 5.97398 15.3819H11.359C11.77 15.3819 12.104 15.0479 12.104 14.6369C12.104 14.2259 11.77 13.8929 11.359 13.8929Z",
    fill: "#FFEFDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.359 10.8929H5.97398C5.56298 10.8929 5.22998 11.2259 5.22998 11.6369C5.22998 12.0479 5.56298 12.3819 5.97398 12.3819H11.359C11.77 12.3819 12.104 12.0479 12.104 11.6369C12.104 11.2259 11.77 10.8929 11.359 10.8929Z",
    fill: "#FFEFDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewCaseActive);
export default __webpack_public_path__ + "static/media/Icon.NewCaseActive.f4dbcf21c700ece45511e15a4de9c4a7.svg";
export { ForwardRef as ReactComponent };